import React, { useState, useEffect } from "react";
import { Tab, Tabs, Typography } from "@mui/material";
import DemographicsDashboard from "./MetabaseDashboards/DemographicsDashboard";
import OperationsDashboard from "./MetabaseDashboards/OperationsDashboard";
import HRDashboard from "./MetabaseDashboards/HRDashboard";
import FinancialDashboard from "./MetabaseDashboards/FinancialDashboard";
import CustomerDashboard from "./MetabaseDashboards/CustomerDashboard";
import EmployeeDashboard from "./MetabaseDashboards/EmployeeDashboard";
import CompanyDashboard from "./MetabaseDashboards/CompanyDashboard";
import UnitsDashboard from "./MetabaseDashboards/UnitsDashboard";
import EVVDashboard from "./MetabaseDashboards/EVVDashboard";

export default function BI_Dashboards(props) {
    const [activeKey, setActiveKey] = useState("demographicsDashboard");

    const pBusinessType = props.user?.comp_settings.find(setting => setting.feature_value === 'primaryBusinessType') ? props.user.comp_settings.filter((setting) => setting.feature_value === "primaryBusinessType")[0].feature_id : -1;
    const stateID = props.user?.comp_settings.find(setting => setting.feature_id === 99) ? props.user.comp_settings.filter((setting) => setting.feature_id === 99)[0].state_id : '';
    const isAdmin = props.user.type === 'Admin';

    const handleKeyChange = (event, activeKey) => {
        setActiveKey(activeKey);
    };

    useEffect(() => {
        setActiveKey(props.activeSubKey || "demographicsDashboard")
    }, [props.activeSubKey]);

    return (
        <div style={{ width: '100%' }}>
            <div>
                <Typography
                    style={{
                        fontWeight: "bold",
                        fontSize: "1.5rem",
                        fontFamily: "Lato",
                        marginBottom: 10,
                        marginLeft: 10
                    }}
                >
                    BI Dashboards
                </Typography>
            </div>
            <div style={{ width: '100%' }}>
                <Tabs
                    value={activeKey}
                    onChange={handleKeyChange}
                    variant="scrollable"
                    sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                        '& .Mui-selected': {
                            backgroundColor: '#f0f0f0',
                            fontWeight: 'bold',
                        },
                        position: 'relative',
                        zIndex: 1,
                        backgroundColor: '#fafafa',
                    }}
                >
                    {props.user.permissions.DemographicsDashboard && <Tab key={"demographicsDashboard"} value={"demographicsDashboard"} label="Demographics" />}
                    {props.user.permissions.OperationsDashboard && <Tab key={"operationsDashboard"} value={"operationsDashboard"} label="Operations" />}
                    {props.user.permissions.HRDashboard && <Tab key={"hrDashboard"} value={"hrDashboard"} label="HR" />}
                    {props.user.permissions.FinancialDashboard && <Tab key={"financialDashboard"} value={"financialDashboard"} label="Financial" />}
                    {props.user.permissions.CustomerDashboard && <Tab key={"customerDashboard"} value={"customerDashboard"} label="Customer" />}
                    {props.user.permissions.EmployeeDashboard && <Tab key={"employeeDashboard"} value={"employeeDashboard"} label="Employee" />}
                    {<Tab key={"companyDashboard"} value={"companyDashboard"} label="Company" />}
                    {<Tab key={"unitsDashboard"} value={"unitsDashboard"} label="Units" />}
                    {props.user.permissions.EVVNJ && isAdmin && <Tab key={"evvDashboard"} value={"evvDashboard"} label="EVV" />}
                </Tabs>

                <div style={{ width: '100%' }}>
                    {activeKey === "demographicsDashboard" && <DemographicsDashboard {...props} />}
                    {activeKey === "operationsDashboard" && <OperationsDashboard {...props} />}
                    {activeKey === "hrDashboard" && <HRDashboard {...props} />}
                    {activeKey === "financialDashboard" && <FinancialDashboard {...props} />}
                    {activeKey === "customerDashboard" && <CustomerDashboard {...props} />}
                    {activeKey === "employeeDashboard" && <EmployeeDashboard {...props} />}
                    {activeKey === "companyDashboard" && <CompanyDashboard {...props} />}
                    {activeKey === "unitsDashboard" && <UnitsDashboard {...props} />}
                    {activeKey === "evvDashboard" && <EVVDashboard {...props} />}
                </div>
            </div>
        </div>
    )
};